import React, { useState, useContext, useRef } from 'react';
import { getImages } from '../Const';
import { LeadsContext } from '../Context/LeadsContext';
import { UserContext } from '../Context/UserContext';

const NotesSection = ({appraisalData, noteTypes, noteTypesExlude, noteTitle}) => {
    const [note, setNote] = useState('');
    const formRef = useRef(null);

    const {addNote} = useContext(LeadsContext);
    const {user} = useContext(UserContext);
    const submitNoteForm = async (e) => {
        e.preventDefault();
        if (!formRef.current || !(formRef.current instanceof HTMLFormElement)) {
            console.error("formRef is not a valid form");
            return;
        }
        const formData = Object.fromEntries(new FormData(e.target));
        const response = await addNote(formData, appraisalData);
        if (response && response.success && response.note) {
            setNote("");
            appraisalData.notes.unshift(response.note);
        } else alert('Error adding note');
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (formRef.current) {
                formRef.current.requestSubmit();
            }
        }
    };
  return (
    <>
        <div className='adb-box'>
            <div className='py-4 ps-4 pe-3'>
                <div className='adb-box-scroll'>
                    {appraisalData.notes && appraisalData.notes.filter(note => noteTypes.length == 0 || noteTypes.includes(note.title)).filter(note => noteTypesExlude.length == 0 || !noteTypesExlude.includes(note.title)).map((note, index) => {
                        const createdAtDate = new Date(note.created_at + " UTC");
                        return (
                            <div className='adb-col mb-3' key={index}>
                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                    <div className='adc-label text-uppercase'>
                                        {note.title == "Sent SMS" && <img className='me-2 adc-xxs-icon' src={getImages('text-sent.svg')}/>}
                                        {note.title == "Sent Email" && <img className='me-2 adc-xxs-icon' src={getImages('email-recevied.svg')}/>}
                                        {note.title == "APPRAISAL NOTES" ? "CREATED BY" : note.title}
                                        <span className='text-lgray ps-2'>
                                            {note.subtitle}
                                        </span>
                                    </div>
                                    <div>
                                        <span className='adr-label font-12 text-llgray pe-3'>{createdAtDate.toLocaleString('en-US', { year: "2-digit", month: "2-digit", day: "numeric", hour: '2-digit', minute: '2-digit', hour12: true })}</span>
                                        <button type='button' className='dot-menu'>
                                            <img src={getImages('dots.png')} alt='menu' />
                                        </button>
                                    </div>
                                </div>
                                <div className='adr-label font-12 text-llgray'>{note.note}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='adb-fields'>
                <form ref={formRef} className='adf-box d-flex align-items-center' onSubmit={(e) => submitNoteForm(e)}>
                    <input type="hidden" name="id" value={appraisalData.id || ""} />
                    <input type="hidden" name="title" value={noteTitle} />
                    <input type="hidden" name="subtitle" value={user && user.first_name && user.last_name ? user.first_name + " " + user.last_name : ""} />
                    <input
                        type='text'
                        name="note"
                        className='form-control'
                        placeholder='Enter note here…'
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                    <button className='blue-btn' type='submit'>
                        ENTER
                    </button>
                </form>
            </div>
        </div>
    </>
  )
}

export default NotesSection